import Script from 'next/script';

import logToDatadog from '@/logger/logToDatadog';

const NoibuScript = () => {
  // eslint-disable-next-line no-process-env
  const env = process.env.NEXT_PUBLIC_OURA_ENV;
  const loadScript =
    env === 'sandbox' || env === 'staging' || env === 'production';

  if (loadScript) {
    return (
      <Script
        id="noibu-script"
        src="https://cdn.noibu.com/collect-core.js"
        strategy="beforeInteractive"
        onError={(error) => {
          logToDatadog({
            error: error,
            message: 'Noibu script failed to load',
            module: 'app',
          });
        }}
      />
    );
  }
  return <></>;
};
export default NoibuScript;
